import Tokenized from "@components/CreditCard/Tokenized";
import useContent from "@lib/use_content";

function Payment({ payment }: { payment: be.Payment }): JSX.Element | null {
  const { data, loading, error } = useContent(["beRessummaryDirectbillPayment"]);

  return (
    <div>
      <div className="mt-3">
        {payment.typeId == "3" ? (
          <p className="prose prose-md">{data?.content.beRessummaryDirectbillPayment}</p>
        ) : (
          <Tokenized tokenizedCard={payment.creditCard} />
        )}
      </div>
    </div>
  );
}

export default Payment;
